import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _IdentityContextConsumerAsObserver;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { PageStateLogger } from "abreact/core/pagestate/PageStateLogger";
import { observer } from "mobx-react";
import * as React from "react";
import { IdentityContext, IdentityUtils } from "./IdentityUtils";
/**
 * This class is critical to how page state works for class components using mobx.
 *
 * This CANNOT be converted to a new style context and MUST be decorated as an observer
 *
 * It is the final component to emit the actual wrapped content, so it becomes the observer
 * of the observables and the target for the reactions. That all works because by the time this is
 * emitted, the component's configuration has been set up. From here on out, the re-render cycles caused
 * by mobx reactions will be within this component
 *
 */
export let IdentityContextConsumerAsObserver = observer(_class = (_IdentityContextConsumerAsObserver = class IdentityContextConsumerAsObserver extends React.Component {
  render() {
    const identity = this.getComponentIdentityIfInfrastructureIsInPlace();
    PageStateLogger.maybeLog("system", `render from IdentityContextConsumerAsObserver for ${IdentityUtils.getBestAvailableIdentifierForComponent(this.props.component)}`);
    return this.props.renderContent({
      componentIdentity: identity
    });
  }
  getComponentIdentityIfInfrastructureIsInPlace() {
    return this.context?.componentIdentity;
  }
}, _defineProperty(_IdentityContextConsumerAsObserver, "contextType", IdentityContext), _IdentityContextConsumerAsObserver)) || _class;
//# sourceMappingURL=IdentityContextComponents.js.map
